import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { BookingsMain } from '../../app-bookings-messages/bookings-messages-main';
import { AcceptedBookings } from '../../app-bookings-messages/data/inbox-page-data';

class InboxMainContainer extends Component {
  componentWillReceiveProps (nextProps) {
    const { profile } = nextProps;

    // if user logs out, redirect to sign in
    if (!profile.SSOid) {
      location.href = '/';
    }
  }

  render () {
    const { isFetching, nav } = this.props;
    const settings = {
      pageObj: AcceptedBookings(nav.messageCount),
      sort: 'accepted',
      limit: 5
    };
    return (
      <div>
        { isFetching
          ? null
          : <BookingsMain
            {...this.props}
            settings={settings}
          />
        }
      </div>
    );
  }
}

InboxMainContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  isFetching: PropTypes.bool.isRequired
};

function mapStateToProps (state) {
  const { auth, profile, nav } = state;

  const {
    isFetching
  } = profile || {
    isFetching: true
  };

  return {
    auth,
    profile,
    nav,
    isFetching
  };
}

export default connect(mapStateToProps)(InboxMainContainer);
